import { Link, Navigate, Route, Routes } from 'react-router-dom'
import { CataloguePage } from './pages/CataloguePage'
import { AdminPage } from './pages/AdminPage'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<CataloguePage />} />
      <Route path="/admin/*" element={<AdminPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="Biblioteca Digital Fecomércio Goiás">
      <img
        src="/logo.png"
        alt="Fecomércio Goiás"
      />
      {!compact && <span>Biblioteca Digital</span>}
    </Link>
  )
}
